export default __webpack_public_path__ + "static/media/14ea76e7d0d04293.b68502b19f7501a215601dba8d3ea6bb.svg";